import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

import { ReactComponent as SummaryIcon } from '../../assets/icons/timecard-summary.svg';

import ArchivedUserWarning from '../ArchivedUserWarning';

export default function TeamMemberCard({
  item,
  selected = false,
  loading = false,
  onClick,
  itemRef,
}) {
  const isSummary = item?.id === 'summary';
  const inactive = item?.active === false || item?.active === 0;
  const className = [
    'team-member-card',
    selected ? 'is-selected' : '',
    isSummary ? 'is-summary' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      ref={itemRef}
      className={className}
      role="option"
      aria-selected={selected}
      onClick={onClick}
    >
      <span className="team-member-card-top">
        <span className="team-member-card-name" title={item?.name}>
          {isSummary && <SummaryIcon />}
          <span className="team-member-card-name-text">{item?.name}</span>
          {inactive && <ArchivedUserWarning />}
        </span>
      </span>
      {loading && (
        <span className="team-member-card-loading">
          <Spin size="small" />
        </span>
      )}
    </button>
  );
}

TeamMemberCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  }).isRequired,
  selected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  itemRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

TeamMemberCard.defaultProps = {
  selected: false,
  loading: false,
  itemRef: undefined,
};
